import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  success: {
    defaultValue: 'Pasta criada com sucesso',
    key: 'create-dashboard-folder-modal-success',
  },
  description: {
    defaultValue: 'Selecione os dashboards que serão adicionados a esta pasta.',
    key: 'create-dashboard-folder-modal-description',
  },
  invalidName: {
    defaultValue: 'Nome de pasta inválido.',
    key: 'create-dashboard-folder-modal-invalidName',
  },
})
